import { AxiosInstance } from "axios";
import { RestService } from "../../RestService";
import Endpoints from "../../server-istances/Endpoints";
import ServerInstanceSingleton from "../../server-istances/Stor-Server/ServerInstance";
import SSOService from "../login-services/SSOService";


export class AttachmentService extends RestService {
    public apiVersion = 'v1';
    static getChoiceList: any;
    private readonly urls: Endpoints;
    private serverInstance: AxiosInstance;

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(){
        super();
        this.urls = new Endpoints();
        const server = ServerInstanceSingleton.getInstance();
        this.serverInstance =  server.getAxiosInstance();
    }

    public async uploadFileToStor(input: any): Promise<any> {
        try {
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/attachment',
                input,
                {headers: this.createHttpMultipartGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async uploadFileByFilenet(input: any, storId:string): Promise<any> {
        try {
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/folder/' + storId,
                input,
                {headers: this.createHttpMultipartGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

        
    public async deleteFileByFilenet(id: string, idDir:string): Promise<any> {
        try {
            return await this.serverInstance.delete(
                this.SEGNALAZIONI_SERVICE_BASE_URL  + '/folder/' + id + '/' + idDir,
                {headers: this.createHttpMultipartGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async downloadFileFromStor(documentId: number): Promise<any | undefined> {
        try {
            return await this.serverInstance.get(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/attachment/' + documentId,
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getValidAccessTokenOrLogin(): Promise<string> {
        const sso = SSOService.getInstance();
        const token = sso.getAccessToken();
        if (token && !sso.isAccessTokenExpired()) return token;
        const refreshToken = sso.getRefreshToken();
        if (refreshToken) {
            try {
                const newToken = await ServerInstanceSingleton.getInstance().updateTokenFromRefresh();
                return newToken;
            } catch (e) {
                sso.doLogin();
                throw e;
            }
        }
        sso.doLogin();
        throw new Error("No refresh token; redirecting to login");
    }

    public async openFileInNewWindow(id: number) {
        const token = await this.getValidAccessTokenOrLogin();
        const urls = Endpoints.getInstance();
        const path = urls.ENV_API_PATH;

        const url =
            path + this.SEGNALAZIONI_SERVICE_BASE_URL + `/attachment/${id}?token=${encodeURIComponent(token)}`;

        window.open(url, "_blank");
    }

    public async openFileInNewWindowStampone(id: any) {
        const token = await this.getValidAccessTokenOrLogin();
        const urls = Endpoints.getInstance();
        const path = urls.ENV_API_PATH;

        const url =
            path + this.SEGNALAZIONI_SERVICE_BASE_URL + `/pdf_formatted/${id}?token=${encodeURIComponent(token)}`;

        window.open(url, "_blank");
    }

    public async openFileInNewWindowExcel(filter: any) {
        const token = await this.getValidAccessTokenOrLogin();
        const urls = Endpoints.getInstance();
        const path = urls.ENV_API_PATH;

        const url =
            path +
            this.SEGNALAZIONI_SERVICE_BASE_URL +
            `/excel/generateExcelStor?token=${encodeURIComponent(token)}`;

        window.open(url, "_blank");
    }

    public async openFileInNewWindowByFilenet(id: string, idDir: string) {
        const token = await this.getValidAccessTokenOrLogin();
        const urls = Endpoints.getInstance();
        const path = urls.ENV_API_PATH;

        const url =
            path +
            this.SEGNALAZIONI_SERVICE_BASE_URL +
            `/folder/${id}/${idDir}?token=${encodeURIComponent(token)}`;

        window.open(url, "_blank");
    }

    public async deleteFileFromStor(documentId: number): Promise<any | undefined> {
        try {
            return await this.serverInstance.delete(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/attachment/' + documentId,
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }
}